<div class="notification-detail-modal" role="dialog" aria-labelledby="notification-title"
  aria-describedby="notification-content">
  <div mat-dialog-title class="modal-header">
    <div class="header-content">
      <img [src]="icon" [alt]="typeClass" [class]="'notification-icon ' + typeClass" aria-hidden="true" />
      <h4 id="notification-title">{{ displayTitle() }}</h4>
    </div>
    <button class="close-button" (click)="close()" [attr.aria-label]="'notifications.detail.close' | translate"
      type="button">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </button>
  </div>

  <mat-dialog-content id="notification-content">
    <div class="notification-content">
      <div class="notification-date">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true">
          <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" stroke-width="2" />
          <path d="M16 2V6M8 2V6M3 10H21" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        </svg>
        <span>{{ notification.createdAt | localizedDate:'datetime' }}</span>
        <span class="relative-time">({{ getRelativeTime(notification.createdAt) }})</span>
      </div>

      <div class="notification-description">
        {{ displayMessage() }}
      </div>

      <div class="notification-status-badge" [class.read]="notification.isRead" [class.unread]="!notification.isRead">
        <span *ngIf="!notification.isRead" class="status-dot"></span>
        {{ notification.isRead ? ('notifications.status.read' | translate) : ('notifications.status.unread' | translate)
        }}
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions *ngIf="showMarkAsReadButton || showMarkAsUnreadButton" align="end">
    <button *ngIf="showMarkAsReadButton" mat-raised-button color="primary" (click)="markAsRead()"
      [disabled]="isMarkingAsRead" type="button" class="mark-as-read-button">
      <span *ngIf="isMarkingAsRead" class="spinner"></span>
      <svg *ngIf="!isMarkingAsRead" width="16" height="16" viewBox="0 0 16 16" fill="none"
        xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M13.3334 4L6.00008 11.3333L2.66675 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
      {{ 'notifications.markAsRead' | translate }}
    </button>
    <button *ngIf="showMarkAsUnreadButton" mat-raised-button color="primary" (click)="markAsUnread()"
      [disabled]="isMarkingAsUnread" type="button" class="mark-as-unread-button">
      <span *ngIf="isMarkingAsUnread" class="spinner"></span>
      <svg *ngIf="!isMarkingAsUnread" width="16" height="16" viewBox="0 0 24 24" fill="none"
        xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path
          d="M3 8L10.89 13.26C11.2187 13.4793 11.6049 13.5963 12 13.5963C12.3951 13.5963 12.7813 13.4793 13.11 13.26L21 8M5 19H19C19.5304 19 20.0391 18.7893 20.4142 18.4142C20.7893 18.0391 21 17.5304 21 17V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19Z"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <circle cx="18" cy="6" r="3" fill="currentColor" />
      </svg>
      {{ 'notifications.markAsUnread' | translate }}
    </button>
  </mat-dialog-actions>
</div>